import { useState } from 'react';
import { API_URL } from '@constants';
import { ApiError, useApiConfig } from '@hooks/useApiConfig';

const ENDPOINT_URL = '/spaces/energy-certificates';

export interface EnergyCertificate {
    uuid: string;
    code: string;
}

export interface GetEnergyCertificatesSuccessResponse {
    status: number;
    success: boolean;
    message: string;
    data: EnergyCertificate[];
    links: Record<string, unknown>;
}

/**
 * Requests endpoint to get all energy certificates.
 */
export const useGetEnergyCertificates = () => {
    const { getHeaders, handleCommonErrors } = useApiConfig();
    const [energyCertificates, setEnergyCertificates] = useState<GetEnergyCertificatesSuccessResponse['data']>([]);
    const [loading, setLoading] = useState<boolean>(false);

    const request = async () => {
        setLoading(true);

        try {
            const response = await fetch(`${API_URL}${ENDPOINT_URL}`, {
                method: 'GET',
                headers: getHeaders(),
            });

            if (!response.ok) {
                const json = await response.json();
                const error = new Error(json.error || '') as ApiError;
                error.statusCode = response.status;
                throw error;
            }

            const data: GetEnergyCertificatesSuccessResponse = await response.json();

            setEnergyCertificates(data.data);
        } catch (err: any) {
            handleCommonErrors(err);
        } finally {
            setLoading(false);
        }
    };

    return { request, energyCertificates, loading };
};
